import styled from 'styled-components';

export const Container = styled.div`
  .order-direction {
    font-size: 0.9em;
    font-weight: bold;
  }
`;
